module.exports = __webpack_public_path__ + "img/passed.76675c8.png";